<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
      :title="page"
      :breadcrumbs="breadcrumbs"
      icon="mdi-package-variant"
    ></vuse-section-definition>
    <v-container fluid>
      <v-col class="mx-1">
        <v-col cols="12">
          <v-row>
            <v-col cols="12" class="content_category mb-3 rounded-lg">
              <v-row class="pl-3">
                <v-col cols="12" class="content_category rounded-lg d-flex">
                  <h3 class="mt-2">Banner</h3>
                  <v-btn
                    class="ml-5 mb-5"
                    color="primary"
                    @click="addBanner()"
                  >
                    Thêm
                  </v-btn>
                </v-col>
                <v-col cols="6" class="content_category mb-3 rounded-lg" v-for="(item, index) in banners" :key="index">
                  <form-link class="content_category mr-2 rounded-lg content_banner" :banner="item" @updateBanner="updateBanner" @removeBanner="removeBanner" :index="index"> </form-link>
                </v-col>
              </v-row>
          </v-col>
            <v-col cols="5.5" class="content_category mr-2 rounded-lg">
              <v-col>
                <p>Sub_Banner</p>
                <v-col cols="12">
                  <v-row>
                    <v-col cols="6">
                      <v-row>
                        <v-col cols="7" class="ps-0">
                          <v-file-input
                            label="Ảnh desktop"
                            placeholder="Tải ảnh lên"
                            prepend-icon="mdi-camera"
                            @change="fileBannerDesktopSub"
                          ></v-file-input>
                        </v-col>
                        <v-col cols="6" class="ps-0" >
                          <v-img :src="srcBannerDestopSub" width="300px"></v-img>
                          <v-text-field v-if="srcBannerDestopSub"
                              class="w-300"
                              background-color="#EDF2F7"
                              filled
                              label="Alt ảnh desktop"
                              v-model="sub_banner_alt_image"
                              placeholder="Nhập alt"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="6">
                      <v-row>
                        <v-col cols="7" class="ps-0">
                          <v-file-input
                            label="Ảnh mobile"
                            placeholder="Tải ảnh lên"
                            prepend-icon="mdi-camera"
                            @change="fileBannerMobileSub"
                          ></v-file-input>
                        </v-col>
                        <v-col cols="6" class="ps-0">
                          <v-img :src="srcBannerMobileSub" width="300px"></v-img>
                          <v-text-field v-if="srcBannerMobileSub"
                              class="w-300"
                              background-color="#EDF2F7"
                              filled
                              label="Alt ảnh mobile"
                              v-model="sub_banner_alt_image_mobile"
                              placeholder="Nhập alt"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
              </v-col>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" class="mt-2">
          <v-row>
            <v-col cols="5.5" class="content_category mr-2 rounded-lg">
              <v-col>
                <v-row class="mb-2">
                  <v-row>
                    <h3 class="ml-6 mt-6">Khoảnh khắc sành điệu</h3>
                    <v-btn class="ml-5 mb-5 mt-5" color="primary" @click="addStep()">
                      Thêm
                    </v-btn>
                  </v-row>
                </v-row>
                  <v-divider></v-divider>
                <v-row>
                  <v-col>
                    <div
                      class="content_property mt-5 rounded-lg"
                      v-for="(itemStep, index) in steps"
                      :key="index"
                    >
                      <v-col>
                        <div style="display: flex; justify-content: flex-end">
                          <v-btn color="primary" @click="clearStep(index)">
                            Xóa
                          </v-btn>
                        </div>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field
                          v-model="itemStep.title"
                          background-color="#EDF2F7"
                          filled
                          item-text="name"
                          item-value="id"
                          label="Giới thiệu"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="6">
                        <v-col cols="6">
                          <v-file-input
                            label="Ảnh"
                            placeholder="Tải ảnh lên"
                            prepend-icon="mdi-camera"
                            @change="fileSelectStep($event, index)"
                          ></v-file-input>
                        </v-col>
                        <v-col>
                          <v-img
                            :src="steps[index].photo"
                          ></v-img>
                          <v-text-field v-if="steps[index].photo"
                              class="w-300"
                              background-color="#EDF2F7"
                              filled
                              label="Alt ảnh"
                              v-model="steps[index].alt_image"
                              placeholder="Nhập alt"
                          ></v-text-field>
                        </v-col
                      ></v-col>
                      <v-col cols="12">
                        <div class="mx-2">
                          <v-row>
                            <v-row class="mb-3">
                              <h3 class="ml-6 mt-2">Category</h3>
                              <v-btn
                                class="ml-5 mb-5"
                                color="primary"
                                @click="addCategoryStep(index)"
                              >
                                Thêm
                              </v-btn>
                            </v-row>
                          </v-row>
                          <v-divider></v-divider>
                          <div
                            v-for="(item, indexChil) in steps[index].categories"
                            :key="indexChil"
                          >
                            <v-autocomplete
                              outlined
                              v-model="item.id"
                              :items="categories"
                              item-text="name"
                              item-value="id"
                              dense
                              append-icon="mdi-delete"
                              @click:append="clearCategoryStep(indexChil, index)"
                            ></v-autocomplete>
                          </div>
                        </div>
                      </v-col>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-col>
            <v-col cols="5.5" class="content_category mr-2 rounded-lg">
              <v-col>
                <v-col>
                  <v-row>
                    <h3 class="ml-1 mt-2 mb-3">Cấu hình số lượng sản phẩm hiển thị trên 1 hàng </h3>
                  </v-row>
                </v-col>
                <v-col cols="12" class="mb-3">
                  <v-row>
                    <v-row>
                      <v-col cols="6">
                        <v-text-field
                            background-color="#EDF2F7"
                            filled
                            label="Số lượng phần tử hiện thị trên 1 hàng"
                            v-model="number_product_on_row"
                            placeholder="Nhập số lượng"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="6">
                        <v-text-field
                            background-color="#EDF2F7"
                            filled
                            label="Số lượng phần tử hiện thị trên 1 hàng giao diện mobile"
                            v-model="number_product_on_row_mobile"
                            placeholder="Nhập số lượng"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-row>
                </v-col>
                <v-col>
                  <v-row>
                    <h3 class="ml-1 mt-2">Categories có hiển thị sản phẩm</h3>
                    <v-btn
                      class="ml-5 mb-5"
                      color="primary"
                      @click="addCategory()"
                    >
                      Thêm
                    </v-btn>
                  </v-row>
                </v-col>
                <v-col cols="12">
                  <div
                    v-for="(item, indexCategories) in categoryIds"
                    :key="indexCategories"
                  >
                    <v-row class="mb-3">
                      <v-col cols="5" class="ma-0 pa-0 pr-1">
                        <v-autocomplete
                          v-model="item.category_id"
                          background-color="#EDF2F7"
                          filled
                          item-value="id"
                          item-text="name"
                          :items="categories"
                          label="Topcategory"
                          placeholder="Chọn category"
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols="5" class="ma-0 pa-0 pr-1">
                        <v-text-field
                            background-color="#EDF2F7"
                            filled
                            :text="item.limit"
                            v-model="item.limit"
                            label="Số lượng sản phẩm"
                            placeholder="Số lượng sản phẩm"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="2" class="ma-0 pa-0">
                        <v-btn
                          class="ma-2"
                          outlined
                          large
                          color="indigo"
                          @click="clearCategory(indexCategories)"
                        >
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </div>
                </v-col>
              </v-col>
            </v-col>
          </v-row>
        </v-col>
      </v-col>
      <v-col cols="12" class="text-center mt-3">
        <v-btn color="primary" width="180" @click="save()"> Lưu </v-btn>
      </v-col>
    </v-container>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { GET_LIST_CATEGORY } from "@/store/modules/category";
import {
  GET_LIST_CONFIG_WMF,
  UPDATE_LIST_CONFIG_WMF,
  UPLOAD_WMF_IMAGE,
} from "@/store/modules/configs";
import FormLink from "@/views/Pages/config/util/form_link";
export default {
  components: {
    FormLink,
  },

  data() {
    return {
      categoryIds: [],
      number_product_on_row:null,
      number_product_on_row_mobile:null,
      list_ids: [],
      banners: [],
      steps: [],
      banner: {
          photo_url: "",
          photo_url_mobile: "",
          type: null,
          link: {
            type: null,
            object_id: null,
            url: null,
          }
      },
      types: [
        {
          id: 1,
          text: "Link theo loại",
        },
        {
          id: 2,
          text: "Link theo URL",
        },
      ],
      image: {},
      srcBannerDestopSub: "",
      srcBannerMobileSub: "",
      bannerDestopSub: "",
      bannerMobileSub: "",
      sub_banner_alt_image: "",
      sub_banner_alt_image_mobile: "",
      category: {
        id: -1,
      },

      page: "Quản lý Wmf",

      breadcrumbs: [
        {
          text: "Trang chủ",
          disabled: true,
        },
        {
          text: "Quản lý trang",
          disabled: true,
        },
        {
          text: "Wmf",
          disabled: true,
        },
      ],
      step: {
        title: "",
        categories: [],
        photo: "",
        subTitle: "",
      },
    };
  },
  computed: {
    ...mapGetters({
      categories: "categories",
      config_wmf: "config_wmf",
      //   category: "categoryDetail",
      //   brands: "brands",
      //   tags: "tags",
      //   seos: "seos",
    }),
    _config_wmf : function(){
      return this.config_wmf;
    }
  },
  watch: {
    config_wmf(val) {
      if(typeof val == 'object' && val !== null){
        this.banners = val.banner ?? [];
        this.steps = val.steps ?? [];
        this.categoryIds = (val.categories && val.categories.ids) ? val.categories.ids : [];
        this.number_product_on_row = (val.categories && val.categories.number_product_on_row) ? val.categories.number_product_on_row : null;
        this.number_product_on_row_mobile = (val.categories && val.categories.number_product_on_row_mobile) ? val.categories.number_product_on_row_mobile : null;
        this.srcBannerDestopSub = (val.sub_banner && val.sub_banner.photo_url_path) ? val.sub_banner.photo_url_path : '';
        this.srcBannerMobileSub = (val.sub_banner && val.sub_banner.photo_url_mobile_path) ? val.sub_banner.photo_url_mobile_path : '';
        this.bannerDestopSub = (val.sub_banner && val.sub_banner.photo_url) ? val.sub_banner.photo_url : '';
        this.bannerMobileSub = (val.sub_banner && val.sub_banner.photo_url_mobile) ? val.sub_banner.photo_url_mobile : '';
        this.sub_banner_alt_image = (val.sub_banner && val.sub_banner.alt_image) ? val.sub_banner.alt_image : '';
        this.sub_banner_alt_image_mobile = (val.sub_banner && val.sub_banner.alt_image_mobile) ? val.sub_banner.alt_image_mobile : '';
      }
    }
  },
  async created() {
    await this.$store.dispatch(`${GET_LIST_CATEGORY}`);
    await this.$store.dispatch(`${GET_LIST_CONFIG_WMF}`);
    // await this.$store.dispatch(`${GET_LIST_TAG}`);
  },
  mounted() {},
  methods: {
    addStep() {
      this.step.categories = [];
      this.steps.push({
        title: this.step.title,
        categories: this.step.categories,
        photo: this.step.photo,
        subTitle: this.step.subTitle,
      });
    },
    clearStep(i) {
      this.steps.splice(i, 1);
      this.$forceUpdate();
    },
    addCategoryStep(index) {
      this.steps[index].categories.push({
        id: this.category.id,
      });
    },
    clearCategoryStep(indexChil, indexParent) {
      this.steps[indexParent].categories.splice(indexChil, 1);

      this.$forceUpdate();
    },

    addCategory() {
      this.categoryIds.push({
        category_id: this.category.id,
        limit: 0
      });
    },
    clearCategory(i) {
      this.categoryIds.splice(i, 1);
      this.$forceUpdate();
    },

    fileBannerMobileSub(event) {
      if (!event) {
        console.log(3);
      } else {
        this.image = event;
        this.srcBannerMobileSub = URL.createObjectURL(
          this.image
        );
        let formData = new FormData();
        formData.append("upload", this.image);
        formData.append("type", "banners");
        this.$store.dispatch(`${UPLOAD_WMF_IMAGE}`, formData).then((data) => {
          if (data && data.data && data.data.data) {
            data.data.data.forEach((element) => {
              let data = {
                path: element.path,
                url: element.url,
              };
              this.bannerMobileSub = data.path;
              this.srcBannerMobileSub = data.url;
            });
          }
        });
      }
    },
    fileBannerDesktopSub(event) {
      if (!event) {
        console.log(2);
      } else {
        this.image = event;
        console.log("image", this.image);
        this.srcBannerDestopSub = URL.createObjectURL(this.image);
        let formData = new FormData();
        formData.append("upload", this.image);
        formData.append("type", "banners");
        this.$store.dispatch(`${UPLOAD_WMF_IMAGE}`, formData).then((data) => {
          if (data && data.data && data.data.data) {
            data.data.data.forEach((element) => {
              let data = {
                path: element.path,
                url: element.url,
              };
              this.bannerDestopSub = data.path;
              this.srcBannerDestopSub = data.url;
            });
          }
        });
      }
    },
      fileSelectStep(event, index) {
      // const _this = this;
      if (!event) {
        // this.src_banner_desktop = '';
        // this.category.banner_media = {};
        console.log(4);
      } else {
        // this.properties[index].image = "";
        this.image = event;
        console.log(this.image);
        this.steps[index].photo = URL.createObjectURL(
          this.image
        );
        let formData = new FormData();
        formData.append("upload", this.image);
        formData.append("type", "categories");
        this.$store
          .dispatch(`${UPLOAD_WMF_IMAGE}`, formData)
          .then((data) => {
            if (data && data.data && data.data.data) {
              data.data.data.forEach((element) => {
                console.log(element);
                let data = {
                  path: element.path,
                  url: element.url,
                };
                this.steps[index].photo = data.url;
                this.steps[index].alt_image = "";
                //  this.config_wmf.steps[index].image_path = data.url;
              });
            }
          });
      }
    },
    save() {
      let body = {
        banner: this.banners,
        categories: {
          ids: this.categoryIds,
          number_product_on_row: this.number_product_on_row,
          number_product_on_row_mobile: this.number_product_on_row_mobile
        },
        sub_banner: {
          photo_url: this.bannerDestopSub,
          photo_url_mobile: this.bannerMobileSub,
          alt_image: this.sub_banner_alt_image,
          alt_image_mobile: this.sub_banner_alt_image_mobile,
        },
        steps: this.steps,
      };
      if (body.banner.type == 1) {
        body.banner.link.url = null;
      }
      if (body.banner.type == 2) {
        body.banner.link.object_id = null;
        body.banner.link.type = null;
      }
      this.$store.dispatch(`${UPDATE_LIST_CONFIG_WMF}`, body).then((data) => {
        if (data.status == 1) {
          this.$toasted.success('Cập nhật thành công!', {
            duration:1000,
            position:'top-center'
          })
          this.$store.dispatch(`${GET_LIST_CONFIG_WMF}`);
        } else {
          alert(data.errors);
        }
      });
      console.log("4/8/2022", this.check1);
    },
    addBanner() {
      this.banners.push({
        photo_url: this.banner.photo_url,
        photo_url_mobile: this.banner.photo_url_mobile,
        type: this.banner.type,
        link: this.banner.link,
      });
    },
    updateBanner(val) {
      this.banners[val.index] = val.banner
    },
    removeBanner(i) {
      this.banners.splice(i, 1);
      this.$forceUpdate();
    }

  },
  
};
</script>
<style lang="scss">
.content_property {
  padding: 15px;
  border-style: groove;
}
.content_banner {
  padding: 15px;
  border-style: groove;
}
.content_category1 {
  background: #ffffff !important;
}
.content_category {
  background: #ffffff !important;
  .v-input__control {
    height: 65px !important;
  }
  .content-textarea .v-input__control {
    height: 165px !important;
  }
  .v-input--checkbox .v-input__control {
    height: 20px !important;
  }
}
.production .ck-editor__main .ck-content {
  height: 140px;
}
.right {
  float: right;
}
.w-300{
  width: 300px;
}
</style>